import { InvestorCapitalAccountItemValue } from '../../capital-account/InvestorCapitalAccountItemValue';
import { InvestorCapitalAccountDTO } from './InvestorCapitalAccountDTO';
import { ItemAllocationMethodDTO } from './ItemAllocationMethodDTO';

export class InvestorCapitalAccountItemValueDTO {
  uuid: string;
  investor: InvestorCapitalAccountDTO;
  itemAllocationMethod: ItemAllocationMethodDTO;
  manualValue: number;

  constructor(
    uuid: string,
    investor: InvestorCapitalAccountDTO,
    itemAllocationMethod: ItemAllocationMethodDTO,
    manualValue: number,
  ) {
    this.uuid = uuid;
    this.investor = investor;
    this.itemAllocationMethod = itemAllocationMethod;
    this.manualValue = manualValue;
  }

  static toInvestorCapitalAccountItemMethod(dto: InvestorCapitalAccountItemValueDTO): InvestorCapitalAccountItemValue {
    return new InvestorCapitalAccountItemValue(
      dto.uuid,
      InvestorCapitalAccountDTO.toInvestorCapitalAccount(dto.investor),
      ItemAllocationMethodDTO.toItemAllocationMethod(dto.itemAllocationMethod),
      dto.manualValue,
    );
  }

  static arrayToInvestorCapitalAccountItemValuesList(dtos: InvestorCapitalAccountItemValueDTO[]): InvestorCapitalAccountItemValue[] {
    return dtos?.map((dto) => InvestorCapitalAccountItemValueDTO.toInvestorCapitalAccountItemMethod(dto));
  }
}
